import NamedDto from 'modules/base/dto/NamedDto';

export class TaskManagerEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;

		/** @type {Date} */
		this.startDateTime = null;

		/** @type {Date} */
		this.endDateTime = null;

		/** @type {number} */
		this.reader = null;

		/** @type {number} */
		this.reader = null;

		/** @type {number} */
		this.measurement = null;

		/** @type {number} */
		this.backfill = null;

		/** @type {boolean} */
		this.skipToday = false;

		/** @type {object} */
		this.stateInject = false;

		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _TaskManagerEditDtoProps
	 * @property {string} type
	 * @property {Date} startDateTime
	 * @property {Date} endDateTime
	 * @property {number} reader
	 * @property {number} measurement
	 * @property {number} backfill
	 * @property {boolean} skipToday
	 * @property {object} stateInject
	 * @property {number} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _TaskManagerEditDtoProps} TaskManagerEditDtoProps
	 */
	/**
	 *
	 * @param {TaskManagerEditDtoProps} props
	 * @returns {TaskManagerEditDto}
	 */

	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.startDateTime = props.startDateTime !== null ? new Date(props.startDateTime) : null;
		this.endDateTime = props.endDateTime !== null ? new Date(props.endDateTime) : null;
		this.reader = props.reader;
		this.measurement = props.measurement;
		this.backfill = props.backfill;
		this.skipToday = props.skipToday || false;
		this.stateInject = props.stateInject;
		this.userGroup = props.userGroup;

		return this;
	}
}

export default TaskManagerEditDto;